import { addDays, format } from 'date-fns';
import { Vendor } from '../types/types';

export const generateDisplayIds = (vendor: Vendor, maxApiDaysRange: number): string[] => {
  const allDisplayIds: string[] = [];
  const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
  const endDate = addDays(today, maxApiDaysRange + 1);

  if (vendor.schedule?.repeat && vendor.schedule.repeat !== 'once') {
    let currentDate = new Date(today);
    while (currentDate <= endDate) {
      if (
        !vendor.schedule.days ||
        vendor.schedule.days.length === 0 ||
        vendor.schedule.days.includes(currentDate.getDay())
      ) {
        allDisplayIds.push(`${vendor.id}-${format(currentDate, 'yyyy-MM-dd')}`);
      }
      currentDate = addDays(currentDate, 1);
    }
  } else {
    allDisplayIds.push(`${vendor.id}-${format(today, 'yyyy-MM-dd')}`);
  }

  return allDisplayIds;
};
